import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLelyAuth } from '../../../auth/useLelyAuth';

const useLoginWithRedirect = () => {
  const {
    loginWithRedirect,
    isAuthenticated,
    isLoading: auth0Loading,
  } = useLelyAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthCallback = window.location.pathname === '/auth/callback';
    const isLogoutPage = window.location.pathname === '/logout';
    const urlParams = new URLSearchParams(window.location.search);
    const isBdd = urlParams.get('isBdd') === 'true';

    if (auth0Loading || isLogoutPage) {
      return;
    }

    const redirectUrl = localStorage.getItem('redirectUrl');
    const redirectPath = redirectUrl || '/farms';

    if (isBdd && isAuthenticated) {
      navigate(redirectPath, { replace: true });
    } else if (!isAuthenticated && !isAuthCallback && !isBdd) {
      localStorage.removeItem('redirectUrl');

      loginWithRedirect({
        appState: {
          returnTo: redirectPath,
        },
      });
    }
  }, [isAuthenticated, loginWithRedirect, auth0Loading, navigate]);
};

export default useLoginWithRedirect;
